export default "__VITE_ASSET__kjFqrD$0__"